<script>
import { Doughnut } from "vue-chartjs";

export default {
    name: "KvDoughnutChart",
    extends: Doughnut,
    props: {
        chartData: {
            type: Object,
            required: true,
            default: () => ({ labels: [], datasets: [] }),
        },
        thickness: {
            type: Number,
            default: 20,
        },
        gap: {
            type: Number,
            default: 2,
        },
        showLabels: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            localOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: false },
                cutoutPercentage: 85,
                tooltips: { enabled: false },
                hover: {
                    mode: 'nearest',
                    intersect: true,
                    onHover: this.handleCustomHover
                },
                elements: {
                    arc: {
                        borderWidth: this.gap,
                        borderColor: '#FFFFFF',
                    }
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            },
            originalColors: [],
            totalValue: 0
        };
    },
    computed: {
        dataset() {
            return this.chartData.datasets[0] || {};
        }
    },
    watch: {
        chartData: {
            handler() {
                this.calculateTotal();

                // Verifica se o gráfico já foi criado
                if (this.$data._chart) {
                    // Atualiza os dados do gráfico existente
                    this.$data._chart.data = this.chartData;

                    // Chama o update do Chart.js (preserva animações)
                    this.$data._chart.update();
                } else {
                    // Se o gráfico ainda não existe, cria ele
                    this.renderDoughnut();
                }
            },
            deep: true
        },
    },
    mounted() {
        this.addPlugin({
            id: 'center-text-plugin',
            beforeDraw: (chart) => {
                // 2. Se showLabels for falso, não desenha nada no centro
                if (!this.showLabels) return; // <--- ALTERAÇÃO IMPORTANTE

                const width = chart.chart.width;
                const height = chart.chart.height;
                const ctx = chart.chart.ctx;

                ctx.restore();

                let labelText = this.t('charts-totals');
                let valueText = this.totalValue.toLocaleString('pt-BR');
                let valueColor = "#4D5761";

                const activeElements = chart.active;
                if (activeElements && activeElements.length > 0) {
                    const index = activeElements[0]._index;
                    labelText = this.chartData.labels[index];
                    valueText = parseFloat(this.chartData.datasets[0].data[index]).toLocaleString('pt-BR');
                }

                ctx.font = "14px sans-serif";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                ctx.fillStyle = "#6B7280";
                ctx.fillText(labelText, width / 2, height / 2 + 16);

                ctx.font = "bold 22px sans-serif";
                ctx.fillStyle = valueColor;
                ctx.fillText(valueText, width / 2, height / 2 - 10);

                ctx.save();
            }
        });

        this.calculateTotal();
        this.renderDoughnut();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        calculateTotal() {
            const data = this.dataset.data || [];
            this.totalValue = data.reduce((acc, val) => acc + Number(val), 0);

            if (this.dataset.backgroundColor && this.originalColors.length === 0) {
                this.originalColors = [...this.dataset.backgroundColor];
            }
        },

        handleCustomHover(e, activeElements) {
            // 3. Se for modo "loading" (sem labels), desativa o efeito de hover cinza
            if (!this.showLabels) return; // <--- ALTERAÇÃO PARA EVITAR INTERAÇÃO

            const dataset = this.$data._chart.data.datasets[0];
            if (!dataset) return;

            if (!activeElements || activeElements.length === 0) {
                const isDifferent = dataset.backgroundColor.some((c, i) => c !== this.originalColors[i]);
                if (isDifferent) {
                    dataset.backgroundColor = [...this.originalColors];
                    this.$data._chart.update();
                }
                return;
            }

            const activeIndex = activeElements[0]._index;
            const newColors = this.originalColors.map((color, index) => {
                return index === activeIndex ? color : '#E5E7EB';
            });

            const currentColors = dataset.backgroundColor;
            const needsUpdate = newColors.some((c, i) => c !== currentColors[i]);

            if (needsUpdate) {
                dataset.backgroundColor = newColors;
                this.$data._chart.update();
            }
        },

        renderDoughnut() {
            const size = Math.min(this.width || 1000, this.height || 1000);

            const radius = size / 2;

            let percentageThickness = (this.thickness / radius) * 100;

            let cutout = 100 - percentageThickness;

            if (cutout < 0) cutout = 0; // Gráfico cheio (Pie)
            if (cutout > 98) cutout = 98; // Linha muito fina

            this.localOptions.cutoutPercentage = cutout;

            this.renderChart(this.chartData, this.localOptions);
        }
    }
};
</script>